import {
  type DeploymentLayout,
  type MessageVisibility,
  type ModerationScope,
  type SpaceRenderType
} from '@shared/all/domains/spaces';

export const getSpaceConfig = () => {
  const config = process.env.NEXT_PUBLIC_SPACE_CONFIG;
  if (!config) {
    throw new Error('Space config is not defined');
  }
  const spaceConfig = JSON.parse(config);
  if (!spaceConfig) {
    throw new Error('Space config is not valid JSON');
  }
  return spaceConfig as {
    space: {
      id: number;
      slug: string;
      avatarKey: string;
    };
    spaceRenderType: SpaceRenderType;
    messageVisibility: MessageVisibility;
    moderationScope: ModerationScope;
    layoutType: DeploymentLayout;
  };
};

export const spaceConfig = getSpaceConfig();
